import React, { useState, useContext } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import fetcher from "../../../../dataProvider";
import { setToken, setUserDetail } from "../../../../redux/actions";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useRouter } from "next/router";
import TagManager from "react-gtm-module";
import BuyNFT from "../../../../../components/Buttons/BuyNFT";
import { setUserData } from "../../../../redux/slices/user";
import { CommonContext } from "../../../../../components/helper/commonContext";
import { Box } from "@mui/system";
import { validateEmail } from "../../../../../util/common";
import auth from "../../../../../components/Layout/util/auth";
import nftLandingCss from "../../../../../components/NFTLandingPage/style";
import cookie from "js-cookie";
import {
  callGTMCTAClick,
  enquireNowGTMCTAClick,
} from "../../../../../util/gtmutil";
import { Button, Modal, Typography } from "@mui/material";

const CapturePhoneForm = ({
  toggleSnackbar,
  handleModalClose,
  enquireNow = false,
  callNow = false,
  pagePath,
  songName1,
  newEnquireNowfield,
  handleTelegramPopupOpen,
}) => {
  console.log("CapturePhone Form data", pagePath, songName1);
  const [passwordShown, setPasswordShown] = useState(false);
  const [mobile, setValue] = useState("");
  const [email, setEmail] = useState("");
  const [question1, setQuestion1] = useState("NA");
  const [question2, setQuestion2] = useState("NA");
  const [question3, setQuestion3] = useState("NA");
  const [question4, setQuestion4] = useState("NA");

  const [genderErr, setGenErr] = useState(true);
  const router = useRouter();
  const commonContext = useContext(CommonContext);
  const r = auth();
  const dispatch = useDispatch();
  const { profile, id, userData } = useSelector((state) => state.user);
  console.log("newEnquireNowfield", newEnquireNowfield);

  console.log("user GAID value:\n", profile);

  console.log("cookie value", cookie.get("_gid"));

  const onFormSubmit = (data) => {
    if (customvalidation2 && isValidPhoneNumber(mobile)) {
      if (typeof window !== "undefined") {
        if (callNow) {
          enquireNowGTMCTAClick(
            r,
            "ctaClicks",
            "loggedIn",
            "Guest",
            "Call Now Success",
            mobile,
            userData?.email,
            cookie.get("_gid"),
            pagePath,
            songName1
          );
          callExotell();
        } else {
          let userId = localStorage.getItem("userId");
          updatePhoneNo(userId);
        }
      }
    } else {
      alert("Please provide valid mobile number");
    }
  };

  const customvalidation2 =
    (mobile && mobile.length > 13) ||
    mobile == "+911000000000" ||
    mobile == "+911111111111" ||
    mobile == "+91000000000"
      ? false
      : true;

  console.log(
    "🚀 ~ file: CapturePhoneForm.js ~ line 82 ~ customvalidation2",
    customvalidation2
  );
  const onFormSubmitEnquire = () => {
    // const customvalidation = () => {
    //   if (length(mobile) > 12 & mobile != +91000000000) {
    //     return false
    //   }
    //   return true
    // }

    // customvalidation();

    if (
      customvalidation2 &&
      isValidPhoneNumber(mobile) &&
      validateEmail(email)
    ) {
      enquireNowApi();
      enquireNowGTMCTAClick(
        r,
        "ctaClicks",
        "loggedIn",
        "Guest",
        "Enquire Now Success",
        mobile,
        email,
        cookie.get("_gid"),
        pagePath,
        songName1,
        question1,
        question2,
        question3,
        question4
      );
    } else {
      console.log("customcheck", customvalidation2);
      alert("Please provide valid mobile number and email");
    }
  };

  const { mutate: callExotell } = useMutation(
    () => fetcher.post("v1/user/request-callback", { mobile: mobile }),
    {
      onSuccess: (response) => {
        callGTMCTAClick(
          r,
          "enquireNow",
          "login",
          "Guest",
          mobile,
          userData?.email,
          cookie.get("_gid"),
          pagePath,
          songName1
        );
        handleModalClose();

        toggleSnackbar({
          show: true,
          status: "success",
          message: "We will call you Shortly",
        });
        // router.push("/");
        handleTelegramPopupOpen();
        console.log("response", response);
      },
      onError: (error) => {
        handleModalClose();
        console.log("Error", error);
      },
    }
  );
  const { mutate: enquireNowApi } = useMutation(
    () =>
      fetcher.post("v1/user/enquiry", {
        mobile: mobile,
        email: email,
        page: pagePath,
        song: songName1,
        googleAnalyticsId: cookie.get("_gid"),
        investmentExperience: question1,
        hasBoughtNftBefore: question2,
        royaltyUnderstanding: question3,
        moneyInvestment: question4,
      }),
    {
      onSuccess: (response) => {
        handleModalClose();
        setQuestion1("NA");
        setQuestion2("NA");
        setQuestion3("NA");
        setQuestion4("NA");
        toggleSnackbar({
          show: true,
          status: "success",
          message: "We have received your request and we will connect you soon",
        });
        handleTelegramPopupOpen();
        callGTMCTAClick(
          r,
          "enquireNow",
          "login",
          "Guest",
          mobile,
          email,
          cookie.get("_gid"),
          pagePath,
          songName1
        );
        // router.push("/");

        console.log("response", response);
      },
      onError: (error) => {
        handleModalClose();
        console.log("Error", error);
      },
    }
  );

  const { mutate: updatePhoneNo } = useMutation(
    (id) => fetcher.patch(`/v1/user/${id}`, { mobile: mobile }),
    {
      onSuccess: (response) => {
        handleModalClose();
        if (typeof window != "undefined") {
          dispatch(
            setUserDetail({
              ...profile,
              mobile: mobile,
            })
          );
          dispatch(setUserData(response));
          if (localStorage.getItem("nftAction") == "BuyNFT") {
            if (router.pathname.split("/")[1] == "new-nft") {
              commonContext.setMobileUpdated(true);
            } else {
              if (localStorage?.getItem("is_tradable") == "true") {
                router.push({
                  pathname: "/payment/BuyTradeNft",
                  query: { tier_id: localStorage?.getItem("tierId") },
                });
              } else {
                router.push({
                  pathname: "/payment/BuyNowNft",
                  query: { tier_id: localStorage?.getItem("tierId") },
                });
              }
              //BuyNFT
            }
          }
        }
      },
      onError: (error) => {
        alert(error?.response?.data?.message);
        console.log("Error", error);
      },
    }
  );

  const { mutate: ReserveNFT } = useMutation(
    (requestBody) => fetcher.post(`v1/nft/reserve`, requestBody),
    {
      onSuccess: (res) => {
        var tierId;
        var tokenName;
        var tokenCategory;
        var tokenPrice;
        var tokenOwnership;
        if (typeof window != "undefined") {
          tierId = localStorage.getItem("tierId");
          tokenName = localStorage.getItem("tokenName");
          tokenCategory = localStorage.getItem("tokenCategory");
          tokenPrice = localStorage.getItem("tokenPrice");
          tokenOwnership = localStorage.getItem("tokenOwnership");
          const tagManagerArgs = {
            dataLayer: {
              event: "tokenReserved",
              tokenName: tokenName,
              tokenCategory: tokenCategory,
              tokenPrice: tokenPrice,
              tokenOwnership: tokenOwnership,
            },
          };
          TagManager.dataLayer(tagManagerArgs);
          router.push({
            pathname: "/payment/ReserveNowNft",
            query: { tier_id: localStorage?.getItem("tierId") },
          });
        }
      },
      onError: (error) => {
        alert(error.response.data.message);
        console.log("Error message Print ===", error);
      },
    }
  );

  const { mutate: BuyNFT } = useMutation(
    (requestBody) => fetcher.post(`v1/nft/reserve`, requestBody),
    {
      onSuccess: (res) => {
        var tierId;
        var tokenName;
        var tokenCategory;
        var tokenPrice;
        var tokenOwnership;
        if (typeof window != "undefined") {
          tierId = localStorage.getItem("tierId");
          tokenName = localStorage.getItem("tokenName");
          tokenCategory = localStorage.getItem("tokenCategory");
          tokenPrice = localStorage.getItem("tokenPrice");
          tokenOwnership = localStorage.getItem("tokenOwnership");
          const tagManagerArgs = {
            dataLayer: {
              event: "tokenReserved",
              tokenName: tokenName,
              tokenCategory: tokenCategory,
              tokenPrice: tokenPrice,
              tokenOwnership: tokenOwnership,
            },
          };
          TagManager.dataLayer(tagManagerArgs);
          router.push({
            pathname: "/payment/ReserveNowNft",
            query: { tier_id: localStorage?.getItem("tierId") },
          });
        }
      },
      onError: (error) => {
        alert(error.response.data.message);
        console.log("Error message Print ===", error);
      },
    }
  );

  const [agree, setAgree] = useState(true);

  const checkboxHandler = () => {
    setAgree(!agree);
  };

  console.log("Print open state value:", open);
  return (
    <div>
      <Box className="inputBox">
        <Box sx={nftLandingCss.formContainer}>
          {enquireNow && (
            <Box
              display="flex"
              alignItems="center"
              style={{ marginBottom: "30px" }}
            >
              <Box
                component="img"
                src="/images/token/email-icon.png"
                style={{ height: "23px", width: "30px" }}
              ></Box>
              <Box width="-webkit-fill-available">
                <input
                  type="text"
                  className={"form-control"}
                  style={{ width: "98%", marginLeft: "10px" }}
                  placeholder="Enter Email*"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  name="email"
                  // requiredMessage="This field is required."
                  // errorTarget="under"
                />
              </Box>
            </Box>
          )}
          <PhoneInput
            style={{ marginBottom: "30px" }}
            international
            countryCallingCodeEditable={false}
            defaultCountry="IN"
            placeholder="Enter phone number"
            value={mobile}
            onChange={setValue}
          />

          {newEnquireNowfield && (
            <>
              {/* first question */}
              <Box sx={nftLandingCss.formGroup}>
                <Typography component="p" className="text-disabled">
                  What’s your investing experience?
                </Typography>
                <select
                  value={question1}
                  onChange={(e) => setQuestion1(e.target.value)}
                  sx={nftLandingCss.inputField}
                >
                  <option value="NA">Select</option>
                  <option value="Never">Never Invested before</option>
                  <option value="1-3 years">1-3 years</option>
                  <option value="3+ years">3+ years</option>
                </select>
              </Box>
              {/* second question */}
              <Box sx={nftLandingCss.formGroup}>
                <Typography component="p" className="text-disabled">
                  Have you bought NFT/Crypto before?
                </Typography>
                <select
                  value={question2}
                  onChange={(e) => setQuestion2(e.target.value)}
                  sx={nftLandingCss.inputField}
                >
                  <option value="NA">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </Box>

              {/* third question */}
              <Box sx={nftLandingCss.formGroup}>
                <Typography component="p" className="text-disabled">
                  What do you understand by royalities?
                </Typography>
                <select
                  value={question3}
                  onChange={(e) => setQuestion3(e.target.value)}
                  sx={nftLandingCss.inputField}
                >
                  <option value="NA">Select</option>
                  <option value="Completely understand">
                    Completely understand
                  </option>
                  <option value=" I have basic idea">I have basic idea</option>
                  <option value="I have no idea">I have no idea</option>
                </select>
              </Box>

              {/* fourth question */}
              <Box sx={nftLandingCss.formGroup}>
                <Typography component="p" className="text-disabled">
                  How much money are you ready to invest?
                </Typography>
                <select
                  value={question4}
                  onChange={(e) => setQuestion4(e.target.value)}
                  sx={nftLandingCss.inputField}
                >
                  <option value="NA">Select</option>
                  <option value="1000>"> &lt;1000</option>
                  <option value="1000-10000>">1000-10000</option>
                  <option value="10000>">&gt;10000</option>
                </select>
              </Box>
            </>
          )}
          {/* {formErrors?.email && <span style={{ color: "red" }}>{formErrors.email}</span>} */}
        </Box>
        {/*  {errors.username && (
          <div style={{ color: "red" }}>{errors.username.message}</div>
        )} */}

        <Box
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginTop: "15px",
          }}
        >
          <input
            type="checkbox"
            style={{
              width: "15px",
              position: "relative",
              top: "4px",
              cursor: "pointer",
            }}
            id="agree"
            defaultChecked={agree}
            onChange={checkboxHandler}
          />
          <div
            style={{
              color: "#fff",
              fontSize: "14px",
              marginLeft: "5px",
              position: "relative",
              padding: "0",
            }}
          >
            {" "}
            I agree to{" "}
            <span
              style={{
                cursor: "pointer !important",
                color: "#e14084",
              }}
              onClick={() => window.open("/terms", "_blank")}
            >
              T&#38;C{" "}
            </span>
            and{" "}
            <span
              style={{ zIndex: 1000, cursor: "pointer", color: "#e14084" }}
              onClick={() => window.open("/privacy", "_blank")}
            >
              Privacy Policy{" "}
            </span>
            and to receive communication &#47; notifications on email &#47;
            WhatsApp &#47;SMS from FanTiger.{" "}
          </div>
        </Box>
      </Box>
      {callNow && (
        <div className="login-button01" style={{ marginTop: "30px" }}>
          <button
            className="btn"
            style={{ zIndex: 9000 }}
            onClick={() => onFormSubmit()}
            disabled={!agree}
          >
            Call Me
          </button>
        </div>
      )}
      {enquireNow && (
        <div className="login-button01" style={{ marginTop: "30px" }}>
          <button
            className="btn"
            style={{ zIndex: 9000 }}
            onClick={() => onFormSubmitEnquire()}
            disabled={!agree}
          >
            Enquire Now
          </button>
        </div>
      )}
      {!callNow && !enquireNow && (
        <div className="login-button01" style={{ marginTop: "30px" }}>
          <button
            className="btn"
            style={{ zIndex: 9000 }}
            onClick={() => onFormSubmit()}
          >
            Continue
          </button>
        </div>
      )}
    </div>
  );
};

export default CapturePhoneForm;
